import styled from 'styled-components';
import { DatePicker} from 'antd';
import {
  PrimaryButtonComponent, DisplayFlex
} from './../../../../CommonComponents/commonStyles'
const { RangePicker } = DatePicker;
export const CustomDatePicker = styled(RangePicker)`
left:-70px;
margin-left:20px;
margin-top:20px;
.ant-calendar-picker-container{
  left: 453px;
  top: 440px;
}
.ant-calendar-range{
  left:-20px;
}
.ant-calendar-range{
 left:-20px;
}
`;

export const DateWrapper = styled.div`
display: flex;
justify-content: center;
position: relative;
background: ${props => props.theme.backgroundColor.layoutLight};
height: 306px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  height: 326px;
  .ant-calendar-picker-container{
    width:100%;
    .ant-calendar{
     width:100%;
    }
  }
}
`;

export const PickTimeFrame = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
  margin-top: 30px;
  width: 100%;
  text-align: center;
  color: ${props => props.theme.fontColors.headingColor};
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
`;
export const ClearTime = styled.div`
  position: relative;
  float: left;
  max-width: 100%;
  line-height: ${props => props.theme.lineHeight.h3};
  height: 30px;
  margin: 4px 2px;
  padding: 0 10px 0 10px;
  color: ${props => props.theme.fontColors.textColor};
  background-color: ${props => props.theme.backgroundColor.lightGrey};
  border: 1px solid ${props => props.theme.border.primary};
  border-radius: 2px;
  cursor: default;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
`;

export const ClearTimeMob = styled.div`
  position: relative;
  float: left;
  max-width: 100%;
  line-height: 30px;
  height: 30px;
  margin: 4px 2px;
  padding: 0 10px 0 10px;
  font-size: ${props => props.theme.fontSize.tertiary};
  color: ${props => props.theme.fontColors.textColor};
  background-color: ${props => props.theme.backgroundColor.lightGrey};
  border: 1px solid ${props => props.theme.border.primary};
  border-radius: 2px;
  cursor: default;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
`;

export const QASectionWrapper = styled.div`
  margin: 15px 0 9px 0;
`;

export const InfoContentWrapper = styled.div`
  padding: 0 30px 30px 30px;
  position: fixed;
  background: ${props => props.theme.backgroundColor.layoutLight};
  width: 56%;
  height: 500px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  .ant-calendar-picker-container{
  left: 0px !important;
  top: 0px !important;
  width:100%;
  .ant-calendar-range{
    width:100%;
  }
  }
  .ant-calendar-input-wrap{
    border-bottom: 0;
  }
  .ant-calendar-range .ant-calendar-body, .ant-calendar-range .ant-calendar-month-panel-body, .ant-calendar-range .ant-calendar-year-panel-body{
    border-top: 0;
  }
  .ant-calendar{
    box-shadow: 0 0 0 rgba(0,0,0,0) !important;
  }
  .ant-calendar-range-left .ant-calendar-input, .ant-calendar-range-left .ant-calendar-time-picker-input{
    text-align: center;
  }
  .ant-calendar-range-right .ant-calendar-input, .ant-calendar-range-right .ant-calendar-time-picker-input{
    text-align: center;
    margin-left: 45px;
  }
  .ant-calendar-range-middle {
    padding-left:201px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 10px 20px 10px;
    .ant-calendar-picker-container{
      position: relative;
      left: unset !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    height: 510px;
    width: 87.5%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    height: 490px;
    width: 74%;
  }
  @media screen and (min-width: 1440px) {
    height: 490px;
    width: 39.5%;
  }
`;

export const InfoWrapper = styled.div`
  position: fixed;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
  
`;
export const DisplayFlexOkay = styled(DisplayFlex)`
  justify-content: center;
  align-items: center;
  height: 18.6%;
  padding: 10px 16px;
`;
export const PrimaryButtonOkay = styled(PrimaryButtonComponent)`
  width: 200px;
  border-radius: 0;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.buttonText};
  cursor: pointer;
  border: none;
  z-index: 1000; 
  @media only screen and (max-width: 990px) {
  width:41%;
  }
`;
export const PopHeader = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  height: 15%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`;
export const IconWrap = styled.div`
  position: absolute;
  right: 23px;
  cursor: pointer;
  margin-top: 23px;
  i {
    font-size: ${props => props.theme.fontSize.h5};
    color: ${props => props.theme.fontColors.textColor};
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-right: 0;
  }
`;

export const MobDatePicker = styled(DatePicker)`

`;